import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import pkg from "../package.json";
const { version } = pkg;
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?version=${version}`,
    },
    fallbackLng: "en-US",
    detection: { order: ["htmlTag", "navigator"] },
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
    defaultNS: "main",
    fallbackNS: "main",
    ns: ["main"],
    supportedLngs: ["en-US", "en-GB"],
  });

export default i18n;
